'use strict';

import jQuery from 'jquery';
import ga from './../../vendor/google-analytics';

/**
 * Confirmation
 *
 * JavaScript functions for the the Sign In page
 */
var Confirmation = (function($) {
  return function(options) {

    // Namespace for private variables and functions
    var privateNS = {
      defaults: { // Namespace for default options
      }
    };

    // Namespace for public variables and functions
    var publicNS = {};

    /**
     * Construct a new instance
     */
    privateNS.init = function() {

      // Initialize options
      privateNS.options = $.extend({}, privateNS.defaults, options);

      // Create a reference to the UI container
      privateNS.$container = $(privateNS.options.container);

      // Create a reference to the accept checkbox
      privateNS.$accept = privateNS.$container.find('.passport-agreement');

      // Create a reference to the confirm button
      privateNS.$confirm = privateNS.$container.find('.confirm');

      // Make sure that the initial button state matches the checkbox state
      privateNS.toggleConfirmState(privateNS.$accept.is(':checked'));

      // Attach the sign in event handlers
      privateNS.attachHandlers();
    };

    /**
     * Handle user interactions with the terms acceptance box
     *
     * @param {boolean} event
     */
    privateNS.toggleAccept = function toggleConfirmCheck(event) {
      privateNS.toggleConfirmState(privateNS.$accept.is(':checked'));

      // Track users interacting with the agreement checkbox
      ga('send', 'event', 'Passport', 'Toggle Terms Agreement', privateNS.$accept.is(':checked') ? 1 : 0);
    };

    /**
     * Handle toggle the state of the confirmation button based on some
     * passing in state
     *
     * @param {boolean} state
     */
    privateNS.toggleConfirmState = function toggleConfirmState(state) {
      privateNS.$confirm.toggleClass('theme-btn', state).toggleClass('disabled-btn', !state);
    };

    /**
     * Attach the event handlers for the show / episode page
     */
    privateNS.attachHandlers = function() {
      privateNS.$accept.on('change', privateNS.toggleAccept);

      privateNS.$confirm.on('click', function(event) {
        if (privateNS.$confirm.hasClass('disabled-btn')) {
          event.preventDefault();
        } else {

          // Track users interacting with the terms submission button
          ga('send', 'event', 'Passport', 'Confirm Terms Agreement');
        }
      });
    };

    // Return a new instance
    return privateNS.init();
  };

})(jQuery);

export default Confirmation